import { graphql } from 'relay-runtime';

export const userTargetGroupGraphQL = graphql`
  query DashboardUserTargetGroupQuery($studentId: ID!, $targetGroupId: ID!) {
    skillStatesByStudentId(studentId: $studentId, filter: { targetGroupId: $targetGroupId }, order: [{ id: ASC }]) {
      id
      inProgress
      readinessScore
      modifiedOn
      createdOn
      skillAssessment {
        score
        isComplete
      }
      skillSubstate {
        id
        name
        skillState {
          id
          name
        }
      }
      skill {
        id
        code
        name
        difficulty
      }
    }
  }
`;

export const getUserGraphQLBE = graphql`
  query DashboardUserBackEndQuery($publicUserId: String!, $skip: Boolean!) {
    hasUserClassWithActiveStudent @skip(if: $skip)
    isInternalUser
    userGuidingHash
    userByPublicUserId(publicUserId: $publicUserId) @skip(if: $skip) {
      id
      firstName
      lastName
      gradeLevels {
        id
        name
      }
      roles {
        name
        summary
      }
      sites(sitesFilter: { isActive: ACTIVE }) {
        id
        name
        timeZone {
          name
        }
        standardState {
          id
          stateStandardName
        }
        targetGroups {
          id
          name
        }
        network {
          id
          name
          customBranding
        }
      }
    }
  }
`;

export const getUserGraphQLBEStudent = graphql`
  query DashboardUserStudentBackEndQuery($publicUserId: String!) {
    userGuidingHash
    isInternalUser
    userByPublicUserId(publicUserId: $publicUserId) {
      id
      firstName
      lastName
      gradeLevels {
        id
        name
      }
      roles {
        name
        summary
      }
      sites(sitesFilter: { isActive: ACTIVE }) {
        id
        name
        siteSchoolYears {
          startOn
          endOn
          schoolYear {
            defaultEndOn
          }
        }
        timeZone {
          name
        }
        targetGroups {
          id
          name
        }
        standardState {
          id
          stateStandardName
        }
        network {
          id
          name
          customBranding
        }
      }
    }
  }
`;

export const getDiagnosticInformation = graphql`
  query DashboardDiagnosticQuery($studentId: ID!, $skip: Boolean!) {
    currentTargetGroupByStudentId(studentId: $studentId) @skip(if: $skip) {
      id
      isCurrent
      isActive
      targetGroup {
        id
        name
        targets(filter: { isActive: ACTIVE }) {
          id
          name
          summary
          targetGroup {
            id
          }
        }
      }
      user {
        id
      }
    }
    latestCompletedStudentSkillDiagnostic(studentId: $studentId) @skip(if: $skip) {
      id
      isComplete
      id
      retakeAssigned
      isInferred
    }
  }
`;

export const getDiagnosticIsInferred = graphql`
  query DashboardDiagnosticIsInferredQuery($studentId: ID!) {
    latestCompletedStudentSkillDiagnostic(studentId: $studentId) {
      id
      isInferred
    }
  }
`;

export const getAllUnitsGraphQL = graphql`
  query DashboardAllUnitsQuery($isActive: ActiveRecords!, $targetGroupIsActive: ActiveRecords = BOTH) {
    allTargets(filter: { isActive: $isActive }, targetGroupFilter: { isActive: $targetGroupIsActive }) {
      name
      id
      summary
      targetGroup {
        id
      }
    }
  }
`;

export const getSkillsByTarget = graphql`
  query DashboardSkillsByTargetQuery($targetId: ID!) {
    target(targetId: $targetId) {
      targetSkills {
        id
        isActive
        targetSkillType {
          id
          name
        }
        skill {
          id
          name
          code
          difficulty
          skillAncestries(filter: { skillRelevanceIds: ["SkillRelevanceNode:2", "SkillRelevanceNode:3"] }) {
            ancestorSkill {
              id
              name
              code
              difficulty
            }
            skillRelevance {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const getUnitSkillsGraphQL = graphql`
  query DashboardUnitSkillsQuery($studentId: ID!, $targetId: ID!) {
    skillStatesByStudentId(studentId: $studentId, filter: { targetId: $targetId }, order: [{ id: ASC }]) {
      id
      inProgress
      readinessScore
      modifiedOn
      createdOn
      skillAssessment {
        score
        isComplete
      }
      skillSubstate {
        id
        name
        skillState {
          id
          name
        }
      }
      skill {
        id
        code
        name
      }
    }
  }
`;

export const hasStudentsRosteredQuery = graphql`
  query DashboardStudentsRosterQuery {
    hasUserClassWithActiveStudent
  }
`;

export const getFiltersInformationSiteAdmin = graphql`
  query DashboardFiltersSiteQuery($input: ClassesFilterInput) {
    classes(first: 100, classesFilterInput: $input) {
      nodes {
        id
        name
        section
        owner {
          lastName
        }
      }
    }
  }
`;

export const getFiltersInformation = graphql`
  query DashboardFiltersQuery {
    allGradeLevels {
      id
      name
    }
    classes(first: 100, classesFilterInput: { isActive: ACTIVE, siteIsActive: ACTIVE }) {
      nodes {
        id
        name
        section
      }
    }
  }
`;
export const getTotalStudentsFiltered = graphql`
  query DashboardGetStudentsCountQuery($filter: AllStudentsFilterInput!, $skip: Boolean = false) {
    allStudents(filter: $filter) @skip(if: $skip) {
      totalCount
    }
  }
`;

export const getDailySnapshotInfo = graphql`
  query DashboardGetDailySnapshotQuery($filter: StudentSkillAssessmentDailySnapshotFilterInput!) {
    studentsSkillAssessmentsDailySnapshot(filter: $filter) {
      numberOfStudents
      score
    }
  }
`;

export const getDailyStudentDetails = graphql`
  query DashboardStudentsListDailyQuery(
    $filter: StudentSkillAssessmentDailySnapshotFilterInput!
    $score: Int = null
    $skip: Boolean = false
  ) {
    studentsSkillAssessmentsDailySnapshotDetail(filter: $filter, score: $score) @skip(if: $skip) {
      student {
        firstName
        lastName
        id
        publicUserId
      }
      skills {
        name
        code
      }
    }
  }
`;

export const getWeeklySnapshotInfo = graphql`
  query DashboardGetWeeklySnapshotQuery(
    $filter: StudentSkillAssessmentWeeklySnapshotFilterInput!
    $source: WeeklyPaceSkillSource!
  ) {
    studentsSkillAssessmentsWeeklySnapshot(filter: $filter, source: $source) {
      uniqueSkillsPassed
      numberOfStudents
    }
  }
`;

export const getWeeklyStudentDetail = graphql`
  query DashboardStudentsListWeeklyQuery(
    $filter: StudentSkillAssessmentWeeklySnapshotFilterInput!
    $passed: Int = null
    $skip: Boolean!
    $source: WeeklyPaceSkillSource!
  ) {
    studentsSkillAssessmentsWeeklySnapshotDetail(filter: $filter, passedSkills: $passed, source: $source)
      @skip(if: $skip) {
      student {
        firstName
        lastName
        id
        publicUserId
      }
      skills {
        name
        code
      }
    }
  }
`;

export const getGoalMetWeekly = graphql`
  query DashboardGoalMetByWeekQuery(
    $filter: StudentSkillGoalsReportByWeekFilterInput!
    $source: WeeklyPaceSkillSource!
  ) {
    studentSkillGoalsReportByWeek(filter: $filter, source: $source) {
      dateRange {
        fromDate
        toDate
      }
      percentageStudentsPassedGoal
    }
  }
`;

export const getGoalMetPassedOrNot = graphql`
  query DashboardGoalMetPassedOrNotQuery(
    $filter: StudentSkillAssessmentWeeklySnapshotFilterInput!
    $returnMeetOrPassedSkillGoal: Boolean!
    $source: WeeklyPaceSkillSource!
  ) {
    studentSkillGoalsReport(
      filter: $filter
      returnMeetOrPassedSkillGoal: $returnMeetOrPassedSkillGoal
      source: $source
    ) {
      firstName
      lastName
      publicUserId
    }
  }
`;

export const getSkillChallengeAttemptedPerStudent = graphql`
  query DashboardSkillChallengeAttemptedPerStudentQuery($filter: StudentSkillAssessmentWeeklySnapshotFilterInput!) {
    studentSkillAssessmentsReport(filter: $filter, first: 10000) {
      nodes {
        userId
        firstName
        lastName
        publicUserId
        notPassedSkillChallenges
        passedSkillChallenges
        totalSkillChallenges
      }
    }
  }
`;

export const getSkillAssessmentReportDetail = graphql`
  query DashboardSkillAssessmentReportDetalQuery($filter: StudentSkillAssessmentsReportDetailFilterInput!) {
    studentSkillAssessmentsReportDetail(filter: $filter) {
      assessmentCount
      skillCode
      skillId
      skillName
    }
  }
`;

export const getStudentExitSlip = graphql`
  query DashboardGetStudentExitSlipQuery(
    $filter: ClassExitSlipsFilterInput!
    $learnosityExitSlipSessionsFilter: LearnosityExitSlipSessionsFilterInput
  ) {
    classExitSlips(filter: $filter) {
      id
      dueOn
      curriculumLesson {
        skills {
          id
          code
          name
        }
        target {
          id
          name
        }
        id
        number
        name
        hasExitSlip
      }
      learnosityExitSlipSessions(learnosityExitSlipSessionsFilter: $learnosityExitSlipSessionsFilter) {
        activityId
        id
        isComplete
        publicUserId
        score
        maxScore
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const skillsAndTargetsByTargetGroup = graphql`
  query DashboardSkillsAndTargetsByTargetGroupQuery($targetGroupId: ID!) {
    skillsAndTargetsByTargetGroup(targetGroupId: $targetGroupId) {
      skillInfo {
        code
      }
      targetSkills {
        id
        target {
          id
          name
        }
        targetSkillType {
          id
          name
        }
      }
    }
  }
`;

export const getStudentSkillStateBySkillId = graphql`
  query DashboardGetStudentSkillStateBySkillIdQuery($skillIds: [ID!], $studentId: ID!) {
    skillStatesByStudentId(studentId: $studentId, filter: { skillIds: $skillIds }, order: [{ id: ASC }]) {
      id
      inProgress
      readinessScore
      modifiedOn
      createdOn
      skillAssessment {
        score
        isComplete
      }
      skillSubstate {
        id
        name
        skillState {
          id
          name
        }
      }
      skill {
        id
        name
        code
      }
    }
  }
`;

export const getSkillAncestries = graphql`
  query DashboardSkillAncestriesQuery($filter: SkillAncestriesFilterInput, $skip: Boolean!) {
    skillAncestries(filter: $filter) @skip(if: $skip) {
      id
      weight
      isActive
      baseSkillId
      ancestorSkillId
      skillRelevance {
        id
        name
      }
    }
  }
`;

export const getPracticeProblemsActions = graphql`
  query DashboardPracticeProblemsActionsQuery($input: LearnosityPracticeProblemsSessionsFilterInput!) {
    learnosityPracticeProblemsSessions(filter: $input) {
      id
      skill {
        id
      }
    }
  }
`;
